export default __webpack_public_path__ + "static/media/success.6cbbbcd6.svg";